//pt  portuguees
const messages = {
};
module.exports = messages;
